import React, { ChangeEvent, useState } from 'react';

export const useDnD = (onImageChange: (files: File[]) => void, isNotDnD: boolean) => {
    const [isImageOver, setIsImageOver] = useState(false);

    const handleDragEnter = (e: DragEvent) => {
        if (isNotDnD) return;
        e.preventDefault();
        setIsImageOver(true);
    };

    const handleDrop = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsImageOver(false);
        const uploadFiles = Array.from(e.dataTransfer.files);
        onImageChange(uploadFiles);
    };
    const handleDragOver = (e: DragEvent) => {
        e.preventDefault();
        setIsImageOver(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        const { relatedTarget } = e;
        //@ts-ignore
        if (!e.currentTarget.contains(relatedTarget)) {
            setIsImageOver(false);
        }
    };

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        const uploadFiles = Array.from(e.target.files);
        onImageChange(uploadFiles);
        e.target.value = '';
    };
    return {
        handleDragEnter,
        handleDrop,
        handleDragOver,
        handleDragLeave,
        isImageOver,
        handleInputChange,
    };
};
